(function($) {
  const collapsableListings = $('.js-listing-component--collapsable');

  if (!collapsableListings.length) {
    return;
  }
  //collapseChild: mousyLocalize.collapse
  console.log(collapsableListings);
  
  function initListingCollapse(listingComponents) {    
    
    listingComponents.each(function(idx) {
      let component = $(this);
      let dropdownSymbolText = '+';
      let collapseText = mousyLocalize.expand;
      let ariaExpanded = false;
      let componentID = component.find('.listing-component__content').attr('id');

      console.log(componentID);
      

      if (idx == 0) {
        dropdownSymbolText = '-';
        collapseText = mousyLocalize.collapse;
        ariaExpanded = true;
        component.addClass('js-listing-component--expanded');
      }
      
      let dropdownToggle = $('<button />', {
        'class': 'listing-component__dropdown-toggle',
        'aria-expanded': ariaExpanded,
        'aria-controls': componentID
      });
      
      dropdownToggle.append( $('<span />', {'class': 'listing-component__dropdown-symbol', text: dropdownSymbolText}));
      dropdownToggle.append( $('<span />', {'class': 'screen-reader-text', text: collapseText}));
      
      let title = $(this).find('.listing-component__title');
      title.append(dropdownToggle);

      title.click(function(e) {
        e.preventDefault();
        component.toggleClass('js-listing-component--expanded');

        let dropdownSymbol = $(this).find('.listing-component__dropdown-symbol');
        dropdownSymbol.text(dropdownSymbol.text() === '-' ? '+' : '-');

        let srText = $(this).find('.screen-reader-text');
        srText.text(srText.text() == mousyLocalize.expand ? mousyLocalize.collapse : mousyLocalize.expand);

        let listingAria = dropdownToggle.attr('aria-expanded');
        dropdownToggle.attr('aria-expanded', listingAria == 'false' ? 'true' : 'false');
      });
    });
  }

  initListingCollapse(collapsableListings);
})(jQuery);
